export const roleTemplate = (data) => {
    const titles = data.map(user => user.Title);
    const firstRow = [`<option value="alle">Vis alle</option>`];

    const filteredTitle = titles.filter((title,index) => titles.indexOf(title) === index)
        .filter(title => title && title.length > 0)
        .map(title => `
            <option value="${title}">
                ${title}
            </option>
        `).join("");

    return [...firstRow, ...filteredTitle];
};